"use client";

import React from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DigitalExcellenceHero() {
  const selectedPosterUrl = "https://loving-airedale.10web.cloud/wp-content/uploads/2026/03/image_htjb66as.jpg";
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="39156" id="pure-grit-real-swagger" className="dark relative h-screen w-full min-h-[600px] overflow-hidden bg-black text-white !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608243/img/image_htjb66as.jpg)] !bg-[url(https://loving-airedale.10web.cloud/wp-content/uploads/2026/03/image_htjb66as.jpg)]">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay muted loop playsInline poster={selectedPosterUrl} className="h-full w-full object-cover">
          <source src="/videos/hero_background.mp4" type="video/mp4" />
          {}
          <div className="h-full w-full bg-black" />
        </video>
        {}
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div ref={textRef} className={`max-w-5xl transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="mb-6 text-6xl font-bold tracking-tight text-white md:text-7xl lg:text-8xl font-serif">SKIN N' <span className="text-primary" data-ast-id="f:/src/pages/Home/sections/DigitalExcellenceHero.tsx|sig:p8yc2l" data-ast-start="1685" data-ast-end="1728">BONEZ Chicago</span></h1>
          
          <p className="mx-auto mb-10 max-w-2xl text-lg text-white md:text-2xl font-sans">Rock hits from the ‘60s, '70s, '80s, ‘90s, and 2000s</p>
        </div>

        <div ref={buttonRef} className={`transition-all duration-1000 delay-300 ease-out ${buttonVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="relative inline-block">
            {}
            <div className="absolute inset-0 -z-10 rounded-sm bg-primary/30 blur-md animate-pulse" />
            
            <Button asChild size="lg" className="h-14 px-8 text-lg font-bold uppercase tracking-widest bg-primary hover:bg-red-700 text-white rounded-sm shadow-[0_0_20px_rgba(255,0,0,0.4)] transition-transform hover:scale-105">
  <a href="mailto:saorcenc@hotmail.com?subject=Booking Inquiry - Skin'N Bonez&body=Hi, I would like to book the band for..." target="_blank" rel="noopener noreferrer">
    Book The Band
    <ArrowRight className="ml-2 h-5 w-5" />
  </a>
</Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce text-white/70">
        <div className="flex flex-col items-center gap-2">
          <span className="text-xs uppercase tracking-widest font-sans">Scroll</span>
          <div className="h-10 w-[1px] bg-gradient-to-b from-primary to-transparent" />
        </div>
      </div>
    </section>;
}